import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// import HubIcon from "@mui/icons-material/Hub";
import WaterIcon from "@mui/icons-material/Water";
// import RecyclingIcon from "@mui/icons-material/Recycling";
// import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import stewardship from "../../../assets/icons/sea-shore.png";
import community from "../../../assets/icons/partnership.png";
import integrity from "../../../assets/icons/integrity.png";
import innovation from "../../../assets/icons/innovation.png";
import equity from "../../../assets/icons/equity.png";
import resilience from "../../../assets/icons/resilience.png";

const cardStyle = {
  bgcolor: "#fff",
  color: "#4f4f4f",
  border: "1px solid #317ABE",
  "&:hover": {
    borderTop: "5px solid #9DCC49",
    borderRight: "5px solid #9DCC49",
  },
};

const objectList = [
  {
    icon: stewardship,
    title: "Stewardship",
    subtitle:
      "We safeguard Nigeria’s marine and coastal ecosystems as a shared heritage and responsibility, ensuring their integrity for generations to come.",
  },
  {
    icon: community,
    title: "Community Partnership",
    subtitle:
      "We work with coastal communities and fisherfolk as equal partners, recognizing local knowledge, leadership, and ownership as essential to lasting impact.",
  },
  {
    icon: integrity,
    title: "Integrity and Accountability",
    subtitle:
      "We uphold the highest standards of transparency, ethical practice, and responsible governance in all our partnerships and programs.",
  },
  {
    icon: innovation,
    title: "Innovation and Learning",
    subtitle:
      "We apply science, technology, and indigenous knowledge to develop practical solutions, continuously learning and adapting to changing environmental and social conditions.",
  },
  {
    icon: equity,
    title: "Inclusion and Equity",
    subtitle:
      "We promote fair access to opportunities, with a strong focus on women, youth, and underserved coastal populations.",
  },
  {
    icon: resilience,
    title: "Resilience",
    subtitle:
      "We strengthen the capacity of ecosystems and communities to adapt to climate change, environmental shocks, and economic uncertainty.",
  },
];

const CoreValues = () => {
  return (
    <Box margin={{ xs: "20% 0%", sm: "2% 0%" }}>
      <Typography
        variant="h6"
        color="#9DCC49"
        fontWeight={800}
        paddingTop={"4%"}
        paddingBottom={"2%"}
        textAlign={"left"}
      >
        <Box component={"span"}>
          <WaterIcon
            sx={{
              width: 23,
              height: 23,
            }}
          />
        </Box>{" "}
        Our Core Values
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle } = list;
          return (
            <>
              <Grid item xs={12} sm={6} md={4}>
                <Box
                  key={index}
                  component={Card}
                  height={"100%"}
                  padding={{ xs: "4% 4%", sm: "10% 8%" }}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  margin={{ xs: "2% 0%", sm: "4% 0%" }}
                  data-aos={"fade-down"}
                  sx={{ ...cardStyle }}
                >
                  <Box
                    marginBottom={"4%"}
                    display={"flex"}
                    marginLeft={0}
                    // justifyContent={"center"}
                  >
                    {" "}
                    <Box
                      component="img"
                      height={{ xs: "54px", sm: "84px" }}
                      sx={{
                        objectFit: "cover",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      src={icon}
                      alt={"icons"}
                    />
                  </Box>
                  <Typography variant={"h5"} fontWeight={700} paddingTop={"6%"}>
                    {title}
                  </Typography>
                  <Typography variant={"subtitle2"} paddingTop={"6%"}>
                    {subtitle}
                  </Typography>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default CoreValues;
